"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOptionPicker = useOptionPicker;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getMatcherFromOption(option) {
  if (option.value) {
    return function (p, valId) {
      var val = option.value(p);
      var pValId = typeof val === "string" ? val : val.id;
      return valId === pValId;
    };
  }
  return option.matcher || function (p, valId) {
    return p.selectedOptions[option.id] === valId;
  };
}
function getValuesFromProduct(product, options) {
  var ret = {};
  options.forEach(function (option) {
    var matcher = getMatcherFromOption(option);
    ret[option.id] = option.values.find(function (v) {
      return matcher(product, v.id);
    });
  });
  return ret;
}
function getProductFromValues(values, options, products) {
  root: for (var i = 0; i < products.length; i++) {
    var product = products[i];
    for (var j = 0; j < options.length; j++) {
      var option = options[j];
      var matcher = getMatcherFromOption(option);
      if (!matcher(product, values[option.id].id)) {
        continue root;
      }
    }
    return product;
  }
}

/**
 * TODO: this is very inefficient, fix later.
 */
function allPossibleCases(arr) {
  if (arr.length == 1) {
    return arr[0];
  } else {
    var result = [];
    var allCasesOfRest = allPossibleCases(arr.slice(1)); // recur with the rest of array
    for (var i = 0; i < allCasesOfRest.length; i++) {
      for (var j = 0; j < arr[0].length; j++) {
        result.push(_objectSpread(_objectSpread({}, arr[0][j]), allCasesOfRest[i]));
      }
    }
    return result;
  }
}
function cartesianProductForValues(options) {
  var arr = options.map(function (o) {
    return o.values.map(function (v) {
      return (0, _defineProperty2["default"])({}, o.id, v);
    });
  });
  return allPossibleCases(arr);
}
function findAlternativeBasicStrategy(values, mainOption /* it can't change */, options, products) {
  var allCombinations = cartesianProductForValues((0, _toConsumableArray2["default"])(options).reverse());
  for (var i = 0; i < allCombinations.length; i++) {
    var iteratorValues = allCombinations[i];
    if (iteratorValues[mainOption.id].id !== values[mainOption.id].id) {
      // main option MUST be selected
      continue;
    }
    var product = getProductFromValues(iteratorValues, options, products);
    if (product) {
      return product;
    }
  }
}
function useOptionPicker() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$products = config.products,
    products = _config$products === void 0 ? [] : _config$products,
    initialProduct = config.initialProduct,
    _config$options = config.options,
    options = _config$options === void 0 ? [] : _config$options;
  var _useState = (0, _react.useState)(initialProduct),
    product = _useState[0],
    selectProduct = _useState[1];

  // calculate options

  options = options.map(function (option) {
    var newValues = Array.isArray(option.values) ? (0, _toConsumableArray2["default"])(option.values) : [];
    if (option.value) {
      products.forEach(function (product) {
        var ret = option.value(product);
        if (typeof ret === "string") {
          if (!newValues.find(function (x) {
            return x.id === ret;
          })) {
            newValues.push({
              id: ret,
              name: ret
            });
          }
        } else if (typeof ret === "object") {
          if (!newValues.find(function (x) {
            return x.id === ret.id;
          })) {
            newValues.push(ret);
          }
        } else {
          throw new Error("option.value must return string or object");
        }
      });
    }
    return _objectSpread(_objectSpread({}, option), {}, {
      values: newValues
    });
  });
  var selectedValues = getValuesFromProduct(product, options);
  var stateForValue = function stateForValue(selectedOption, selectedValue) {
    var optionId = typeof selectedOption === "object" ? selectedOption.id : selectedOption;
    var option = options.find(function (opt) {
      return opt.id === optionId;
    });
    var valueId = typeof selectedValue === "object" ? selectedValue.id : selectedValue;
    var value = option.values.find(function (val) {
      return val.id === valueId;
    });
    var strategy = option.missingProductStrategy || "hidden";
    var newValues = _objectSpread(_objectSpread({}, selectedValues), {}, (0, _defineProperty2["default"])({}, optionId, value));
    var newProduct = getProductFromValues(newValues, options, products);
    if (newProduct) {
      return newProduct;
    }
    if (strategy === "disabled") {
      return "disabled";
    }
    if (strategy === "alternative") {
      var alternative = findAlternativeBasicStrategy(newValues, option, options, products);
      if (alternative) {
        return alternative;
      }
    }
    return "hidden"; // default
  };
  var selectValue = function selectValue(option, value) {
    if (!value) return;
    var newProduct;
    if (value !== null && value !== void 0 && value.alternativeVariantAvailable) {
      var pickedOptions = {};
      value.alternativeVariantAvailable.pickedOptions.map(function (option) {
        pickedOptions[option.attribute_code] = option.name;
      });
      selectProduct(_objectSpread(_objectSpread({}, value.alternativeVariantAvailable), {}, {
        selectedOptions: pickedOptions
      }));
    } else {
      newProduct = stateForValue(option, value);
    }
    if (typeof newProduct !== "object") {
      console.warn("[useOptionPicker] you can't set option \"".concat(option, "\" to value \"").concat(value, "\" because this combination doesn't exist"));
      return;
    }
    selectProduct(newProduct);
  };
  var retOptions = [];
  options.forEach(function (option) {
    var showAsteriskInfo = false;
    var selectOptions = [];
    option.values.forEach(function (value) {
      var state = stateForValue(option, value);
      if (state === "hidden") {
        return;
      }
      var alternativeVariantAvailable = false;
      if ((option.id === "capacity" || option.id === "diameter") && state === "disabled") {
        if (initialProduct[option.id].id === value.id) {
          showAsteriskInfo = true;
          alternativeVariantAvailable = initialProduct;
        }
        initialProduct.otherVariants.map(function (variant) {
          var variantName = variant.pickedOptions.find(function (variant) {
            return variant.attribute_code === option.id;
          });
          if (variantName.name === value.id) {
            showAsteriskInfo = true;
            alternativeVariantAvailable = variant;
          }
        });
      }
      selectOptions.push(_objectSpread(_objectSpread({}, value), {}, {
        id: value.id,
        product: typeof state === "object" && state,
        alternativeVariantAvailable: alternativeVariantAvailable,
        disabled: !alternativeVariantAvailable && state === "disabled"
      }));
    });
    var selectProps = {
      options: selectOptions,
      value: selectedValues[option.id],
      placeholder: option.name,
      onChange: function onChange(val) {
        selectValue(option, val);
      }
    };
    retOptions.push(_objectSpread(_objectSpread({}, option), {}, {
      showAsteriskInfo: showAsteriskInfo,
      selectProps: selectProps
    }));
  });
  return {
    options: retOptions,
    selectedValues: selectedValues,
    selectValue: selectValue,
    product: product,
    selectProduct: selectProduct,
    stateForValue: stateForValue
  };
}